import moment from "moment-timezone";
import type { UserPreferences } from "../../../../../../../../../types/user-preferences";
import type { Option } from "./types";
import { t } from "i18next";

const NUMBER_OF_STEPS = 4 * 24; // step 15 mins in one hour and 24 hours in one day

export const buildTimeOptions = (
  userPreferences: UserPreferences,
  noneTime?: boolean,
): Option[] => {
  const timeFormat =
    userPreferences.locale.time_format === "24h" ? "HH:mm" : "hh:mm A";

  let time = moment().tz("UTC").set({
    hour: 24,
    minute: 0,
    second: 0,
    millisecond: 0,
  });
  const step = 15;

  const options: Option[] = [];

  if (noneTime === true) {
    options.push({
      label: t("date-editor.none-time-label"),
      value: undefined,
    });
  }

  while (options.length < NUMBER_OF_STEPS) {
    const minutes = time.hours() * 60 + time.minutes();
    options.push({
      label: time.format(timeFormat),
      value: minutes * 60 * 1000,
    });
    time = time.add(step, "minutes");
  }
  return options;
};
